'use strict';

module.exports = {
  __depends__: [ require(242) ],
  __init__: [ 'palette' ],
  palette: [ 'type', require(212) ]
};
